import { propertyListings } from "../../data/properties"


const PropertyListing = () => {

    return (
        <section id="listings" className="pdtopBottmSection">
            <div className="container">
            <div className="section-label">Featured Properties</div>
            <h2 className="section-title reveal">Current <em>Listings</em></h2>

                <div className="listings-grid">
                    {propertyListings.map((property) => (
                        <article className="listing-card reveal">
                        <div className="listing-image">
                            <img src={property.image} alt={property.name} />
                        </div>
                        <div className="listing-tag">{property.tag}</div>
                        <div className="listing-body">
                            <div className="listing-location">{property.location}</div>
                            <h3 className="listing-name">{property.name}</h3>
                            <div className="listing-price">{property.price}</div>
                            <div className="listing-meta">
                            <div className="listing-meta-item">{property.beds}</div>
                            <div className="listing-meta-item">{property.baths}</div>
                            <div className="listing-meta-item">{property.area}</div>
                            </div>
                        </div>
                    </article>
                    ))}
                    
                </div>
            </div>
        </section>
    )
}

export default PropertyListing